"use client";

import { ReactNode } from 'react';
import { Navbar } from './Navbar';
import Footer from './Footer';
import SkipToContent from './SkipToContent';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => (
  <>
    <SkipToContent />
    <Navbar />
    <main id="main-content" tabIndex={-1}>
      {children}
    </main>
    <Footer />
  </>
);

export default Layout;
